import { forwardRef } from "react";
import type { HTMLAttributes, ReactNode } from "react";

interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

const EmptyState = forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ title, description, icon, action, className = "", ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={`flex flex-col items-center justify-center py-16 px-4 text-center ${className}`}
        style={{ fontFamily: "'Courier New', monospace" }}
        {...props}
      >
        {/* Icon */}
        {icon ? (
          <div className="mb-6 text-gray-400">{icon}</div>
        ) : (
          <div className="mb-6 text-6xl text-gray-600">📦</div>
        )}

        {/* Title */}
        <h3 className="text-2xl font-black text-white mb-3 uppercase tracking-wide">
          {title}
        </h3>

        {/* Description */}
        {description && (
          <p className="text-gray-400 text-sm max-w-md mb-6 leading-relaxed">
            {description}
          </p>
        )}

        {/* Action */}
        {action && <div className="mt-2">{action}</div>}
      </div>
    );
  }
);

EmptyState.displayName = "EmptyState";

export default EmptyState;
